import { render, staticRenderFns } from "./VolunteerTicket.vue?vue&type=template&id=68499e85&scoped=true&"
import script from "./VolunteerTicket.vue?vue&type=script&lang=js&"
export * from "./VolunteerTicket.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerTicket.vue?vue&type=style&index=0&id=68499e85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68499e85",
  null
  
)

export default component.exports